import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { post } from "../../../helpers/api_helper";
import { toast } from "react-toastify";

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Utils from "../../Utility";

// actions

import Table from "./Table";
import Loader from "../../../components/Loader";
import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
} from "availity-reactstrap-validation";

const Property = (props) => {
  const { user } = props;
  const [isAddForm, setIsAddForm] = useState(false);
  const [isTable, setIsTable] = useState(true);
  const [currentData, setCurrentData] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleId, setSingleId] = useState(null);
  const [file, setFile] = useState(null);
  const imageInput = useRef();
  console.log("props on company", props);

  const onChangeFile = (event) => {
    // Handle file change logic here
    console.log("File changed:", event.target.files);
  };

  const handleValidSubmit = async (e, v) => {
    console.log("values", v);
    let body = {
      ...v,
      token: user?.token,
    };
    console.log("Form Submitted", body);
    // setLoading(true);
    // return;
    // if (file.substring(0, 4) == "blob") {
    //   const fileData = cropper?.current?.cropper
    //     ?.getCroppedCanvas()
    //     .toDataURL();
    //   const obj = await urltoFile(
    //     fileData,
    //     new Date().getTime() + ".webp",
    //     "image/webp"
    //   );
    //   const temp = await resizeFile(obj);
    //   const form = new FormData();
    //   form.append("image", temp);
    //   const imageRes = await upload("/tender/image_upload", form);
    //   body = { ...body, pdf: imageRes?.data };
    // }
    if (currentData) {
      body = { ...body, tenderId: currentData?._id };
      put("/category", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      post("/category", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            console.log("res from tender", res);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb
          title={Utils.projectName}
          breadcrumbItem={currentData ? `Update Tender!` : `Add category`}
        />
        <div
          className="p-2 main-box-form"
          style={{ marginLeft: "80px", marginRight: "80px" }}
        >
          <AvForm
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              console.log("Form data submitted:", v);
              handleValidSubmit(e, v, "bank");
            }}
          >
            <Row>



              <Col lg={12} md={12}>
                <div className="mb-3">
                  <h4>ADD CATEGORY</h4>
                  <AvField
                    name="title"
                    label="Title *"
                    className="form-control"
                    placeholder="Title"
                    type="text"
                    required
                    value={currentData?.title}
                  />
                </div>
              </Col>

              <br />

            </Row>
            <div className="mt-4">
              <Row>
                <Col md={6}>
                  <button
                    className="btn btn-primary w-100 waves-effect waves-light"
                    style={{
                      backgroundColor: Utils.themeColor,
                      border: "none",
                    }}
                    onClick={() => {
                      setIsAddForm(false);
                    }}
                    type="reset"
                  >
                    Cancel
                  </button>
                </Col>
                <Col md={6}>
                  <button
                    className="btn btn-primary w-100 waves-effect waves-light"
                    type="submit"
                    style={{
                      backgroundColor: Utils.themeColor,
                      border: "none",
                    }}
                  >
                    {currentData ? "Update" : "Add"}
                  </button>
                </Col>
              </Row>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  );
};

Property.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { user } = state.Profile;
  const { company } = state.Company;
  return { user, company };
};

export default withRouter(connect(mapStatetoProps, {})(Property));
